module.exports = __webpack_public_path__ + "media/images/favicon-a1902f61.png";